import { useEnabledFeatures } from 'modules/shift_management/hooks/useEnabledFeatures'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'

import { MainPage } from './MainPage'
import { MainPageOld } from './MainPageOld'

const ShiftManagement = ({ children }: React.PropsWithChildren) => {
  const [{ hasFeatureFlag }] = useEnabledFeatures()
  const [{ view }] = useSchedule()

  return view.isByEmployees ||
    hasFeatureFlag('dev_shift_management_work_areas_graphql_migration') ? (
    <MainPage>{children}</MainPage>
  ) : (
    <MainPageOld>{children}</MainPageOld>
  )
}
// I'm exporting this like this to make sure that we make the API of this
// component as explicit as possible and to try to enforce that the public
// interface it has is small.
export { ShiftManagement }
